/*
* @Author: BoltWang春岩
* @Date:   2016-09-08 18:58:39
* @Last Modified by:   BoltWang春岩
* @Last Modified time: 2016-09-08 18:59:20
*/

'use strict';

var url_util = require('../../../../url_util/url_util');
var location_object = url_util.initByLocation();

var _ = require('lodash');
var tpl = require('./submenu_module_tpl.html');
// 生成 handle 只需执行一次
var handle = _.template(tpl, {variable: 'data'});

var _store = {
	$dom: $('<div>'),
	$html: {},
	$q_service: false,
	callback: function (code) {
		
	}
};

var _control  = {
	init: function () {
		var that = this;
		var data = { 
			activeCode: '',
			data: {}
		};
		// if (window._qiwa && window._qiwa.meta && window._qiwa.meta.submenuInfo
		// 	&& window._qiwa.meta.navList.submenu && window._qiwa.meta.navList.submenu.length) {
		// 	$.each(window._qiwa.meta.navList.submenu, function (i, v) {
		// 		var url_object = url_util.initByUrlString(v.url);
		// 		v.url = url_object
		// 			.s('edit', location_object.search.get('edit'))
		// 			.s('__mobile', location_object.search.get('__mobile'))
		// 			.toString();
		// 	});
		// 	data.data[window._qiwa.meta.submenuInfo.name] = window._qiwa.meta.navList.submenu;
		// 	var html = handle(data);
		// }
		_store.$q_service.then(function (_data) {
			if (_data && _data.submenuInfo
				&& _data.submenu && _data.submenu.length) {
				$.each(_data.submenu, function (i, v) {
					var url_object = url_util.initByUrlString(v.url);
					v.url = url_object
						.s('edit', location_object.search.get('edit'))
						.s('__mobile', location_object.search.get('__mobile'))
						.toString();
				});
				data.data[_data.submenuInfo.name] = _data.submenu;
				var html = handle(data);
				that.bind(html);
			}
		})
	},
	bind: function (html) {
		if (_store.$html.remove) {
			_store.$html.remove();
		}
		_store.$html = $(html).addClass('hidden').appendTo(_store.$dom);
		_store.$html.find('.slide-mask-layer').on('click', function(event) {
			event.preventDefault();
			_store.$html.addClass('hidden');
		});
		_store.$html.find('.slide-item').on('click', function(event) {
			event.preventDefault();
			_store.$html.find('.slide-item.active').removeClass('active');
			var code = $(this).addClass('active').attr('data-code');
			_store.callback(code);
		});
	}
};

// _control.init();

module.exports = {
	init: function ($q_service) {
		_store.$q_service = $q_service;
		_control.init();
		return this;
	},
	$dom: _store.$dom,
	do: function (callback) {
		_store.$html.removeClass('hidden');
		_store.callback = function (code) {
			_store.$html.addClass('hidden');
			callback(code);
		};
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/@souche-f2e/chunyan-util/qiwa-common_m/modules_m/menu_module/modules/submenu_module.js
// module id = 281
// module chunks = 4